/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_NoteInputs */

const en_wb_operations_note = /** @type {(inputs: Wb_Operations_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The address wasn’t in the email. The order stays on hold until a person confirms it.`)
};

const lv_wb_operations_note = /** @type {(inputs: Wb_Operations_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adrese nebija e-pastā. Pasūtījums paliek aizturēts, līdz to apstiprina cilvēks.`)
};

/**
* | output |
* | --- |
* | "The address wasn’t in the email. The order stays on hold until a person confirms it." |
*
* @param {Wb_Operations_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_note = /** @type {((inputs?: Wb_Operations_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_note(inputs)
	return en_wb_operations_note(inputs)
});